import { render, staticRenderFns } from "./StructurePanel.vue?vue&type=template&id=289ce72f&"
import script from "./StructurePanel.vue?vue&type=script&lang=ts&"
export * from "./StructurePanel.vue?vue&type=script&lang=ts&"
import style0 from "./StructurePanel.vue?vue&type=style&index=0&id=289ce72f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports